import { useQuery } from "@tanstack/react-query";
import { duelRepository } from "@/config/dataSource";
import type { LeagueSummary } from "@/modules/leagues/types/league";

export interface LeagueDuelsSummary {
  leagueId: string;
  leagueName: string;
  /** Desafios que EU preciso responder (aceitar/recusar). */
  pendingForMe: number;
  /** Desafios que eu mandei e ainda esperam resposta. */
  pendingSentByMe: number;
}

/** Mesmo princípio de resiliência do aviso de Perguntas Bônus — uma liga
 * com erro não derruba o aviso das outras. */
export function usePendingDuelsAcrossLeagues(leagues: LeagueSummary[] | undefined, myUid: string | undefined) {
  return useQuery({
    queryKey: ["pending-duels", (leagues ?? []).map((l) => l.id).sort().join(","), myUid ?? "unknown"],
    queryFn: async (): Promise<LeagueDuelsSummary[]> => {
      const results = await Promise.allSettled(
        (leagues ?? []).map(async (league) => {
          const duels = await duelRepository.getMyDuels(league.id);
          const pendingForMe = duels.filter((d) => d.status === "pendente" && d.desafiadoUid === myUid).length;
          const pendingSentByMe = duels.filter((d) => d.status === "pendente" && d.desafianteUid === myUid).length;
          if (pendingForMe === 0 && pendingSentByMe === 0) return null;
          return { leagueId: league.id, leagueName: league.nome, pendingForMe, pendingSentByMe };
        })
      );
      return results
        .filter((r): r is PromiseFulfilledResult<LeagueDuelsSummary | null> => r.status === "fulfilled")
        .map((r) => r.value)
        .filter((v): v is LeagueDuelsSummary => v !== null);
    },
    enabled: Boolean(leagues) && leagues!.length > 0 && Boolean(myUid),
  });
}
